import React from 'react';
import { Box } from '~ui-kit/components/box';
import { Typography } from '~ui-kit/components/typography';
import { theme } from '~ui-kit/theme';

interface PolicyFieldProps {
  label: string;
  children: React.ReactNode;
}

export function PolicyField({ label, children }: PolicyFieldProps) {
  return (
    <Box gridGap={3}>
      <Typography $fontSize="14px" $width="40%">
        {label}
      </Typography>
      <Typography $fontSize="14px" $width="60%" $color={theme.colors.charcoal}>
        {children}
      </Typography>
    </Box>
  );
}
